import { render } from "./App.vue?vue&type=template&id=257fb76b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=257fb76b&lang=css"

import exportComponent from "C:\\Users\\Danka\\Desktop\\VUE PORTAL\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__